import React from 'react';
import { FixedSizeList as List } from 'react-window';
import { Button, Input, Modal, Tooltip } from 'antd';
import { Plus, X } from 'lucide-react';
import { useStoreToggleList } from './campaignElements.controller';

export default function StoreSelectionModal({ isOpen, setIsOpen, selectedStores, setSelectedStores, stores }) {
    const { search, onSearch, displayedStores, isSelected, toggleStore } = useStoreToggleList({ stores, selectedStores, setSelectedStores });

    const Row = React.memo(({ index, style, data }) => {
        const store = data[index];
        const selected = isSelected(store);
        return (
            <div style={style} className="flex flex-row items-center justify-between gap-3 px-3 border-b border-surface-100">
                <div className="min-w-0">
                    <p className="m-0 text-[13px] font-medium text-surface-900 truncate">{store.name}</p>
                    <p className="m-0 text-xs text-surface-500 tabular-nums">{store.rif}</p>
                </div>
                <Tooltip title={selected ? 'Quitar' : 'Agregar'}>
                    <Button
                        size="small"
                        danger={selected}
                        icon={selected ? <X /> : <Plus />}
                        aria-label={selected ? 'Quitar' : 'Agregar'}
                        onClick={() => toggleStore(store)}
                    />
                </Tooltip>
            </div>
        );
    });

    return (
        <Modal
            title="Pisos de Venta"
            open={isOpen}
            cancelText="Cancelar"
            onCancel={() => setIsOpen(false)}
            okButtonProps={{ type: 'default' }}
            onOk={() => setIsOpen(false)}>
            <div className="flex flex-col">
                <Input.Search value={search} onChange={(e) => onSearch(e.target.value)} placeholder="Buscar piso de venta" />
                <div className="mt-2 text-xs text-surface-500 tabular-nums">{selectedStores?.length || 0} seleccionados</div>
                <div className="mt-3 h-96 rounded-lg border border-surface-200 overflow-hidden">
                    <List
                        height={384} // 96 * 4 = 384 (h-96 in pixels)
                        itemCount={displayedStores?.length ?? 0}
                        itemSize={70} // Approximate height of each row
                        width="100%"
                        itemData={displayedStores ?? []}>
                        {Row}
                    </List>
                </div>
            </div>
        </Modal>
    );
}
